<template>
	<div class="select-theme">
		<CardLarge class="center">
			<div class="description">{{ description }}</div>
			<Themes />
			<CTA :disabled="!minimumThemesSelected" :label="buttonLabel" :to="{ name: 'statements' }" />
		</CardLarge>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CTA from '@/components/UI/CTA.vue'
import CardLarge from '@/components/Layout/CardLarge.vue'
import Themes from '@/components/Themes.vue'

export default {
	name: 'SelectTheme',

	components: {
		CTA,
		CardLarge,
		Themes
	},

	computed: {
		...mapState({
			description: (state) => state.dictionary.themes.description,
			buttonLabel: (state) => state.dictionary.themes.button,
			selectedThemes: (state) => state.selectedThemes
		}),

		...mapGetters(['minimumThemesSelected'])
	},
    mounted() {
        window._paq.push(["trackEvent", location.host.split(".")[0], "start"]);
    }
}
</script>

<style lang="scss" scoped>
.select-theme {
	text-align: center;
}

.description {
	color: $blue;
	max-width: 300px;
	margin: 0 auto;
	@include type-strong();
	@include type-large();

	@include media('<=phone') {
		padding-bottom: 20px;
	}

	@include media('>phone') {
		max-width: 430px;
		padding-bottom: 40px;
	}
}

.themes {
	padding-bottom: 40px;
}
</style>
